import {
  props,
  map,
  mergeLeft,
  pathOr,
  pick,
  pickAll,
  pipe,
  prop,
  defaultTo,
  join,
  flatten
} from 'ramda'
import { renameKeys } from '@/utils'
import toString from '@/utils/to-string'

const formatName = userInfo =>
  `</br>${userInfo.last_name}, ${userInfo.first_name} ( ${userInfo.phone_number} )`

const getFullNames = map(pipe(pick(['first_name', 'last_name', 'phone_number']), formatName))

const joinIfDefined = pipe(defaultTo([]), join(', '))

const getTenants = pipe(
  props(['contract_non_signing_tenants', 'contract_signing_tenants']),
  flatten,
  getFullNames,
  joinIfDefined
)
const getLandlords = pipe(prop('contract_landlords'), getFullNames, joinIfDefined)

const getUnitAddress = ({ unit, building }) =>
  toString('<br>', [
    toString(' - ', [unit?.unit_number && `Unit ${unit.unit_number}`, building?.name]),
    `${building?.full_street_name}, ${building?.city} ${building?.state}`,
    building?.zip
  ])

const getInlineUnitAddress = ({ unit, building }) =>
  `${toString(' - ', [
    unit?.unit_number && `Unit ${unit.unit_number}`,
    building?.full_street_name
  ])}, ${toString(' ', [building?.city, building?.state, building?.zip])}`

const getVariables = (listing, contract) =>
  pipe(
    pickAll(['strata_lot_number', 'strata_plan_number', 'start_date']),
    renameKeys({
      strata_lot_number: 'strataLot',
      strata_plan_number: 'strataPlan',
      start_date: 'tenancyStartDate'
    }),
    mergeLeft({
      unitAddress: pathOr('', ['building', 'full_street_name'], listing),
      formKTenantInfo: getTenants(contract),
      landlordNames: getLandlords(contract),
      companyName: '("Landlord(s)")',
      managingInfo: '',
      rentalUnitAddress: getUnitAddress(listing),
      rentalUnitAddressInLine: getInlineUnitAddress(listing)
    })
  )(contract)

export default getVariables
